export enum ChoiceListDisplayType {
    Vertical,
    Horizontal,
    VerticalColumns,
    HorizontalColumns,
}
